import React, {useContext} from 'react';
import ReactSelect from 'react-select';
import {ThemeContext} from 'styled-components';
import {useController} from 'react-hook-form';

const Select = ({
  name, title, options, getOptionValue, disabled, rules = {}, initialValue, ...rest
}) => {
  const {
    field: {
      ref, value, onChange, ...inputProps
    },
  } = useController({
    name,
    rules,
    defaultValue: initialValue || '',
  });
  const themeContext = useContext(ThemeContext);

  let selectValue = value;
  if (!rest.isMulti) {
    selectValue = options.find((option) => (
      getOptionValue ? getOptionValue(option) : option.value) === value);
  }

  return (
    <ReactSelect
      classNamePrefix="react-select"
      options={options}
      getOptionValue={getOptionValue}
      ref={ref}
      isDisabled={disabled}
      placeholder="Please select one…"
      styles={{
        control: (styles, state) => ({
          ...styles,
          borderRadius: 8,
          backgroundColor: themeContext.select.default.bg,
          borderColor: state.isFocused ? themeContext.select.focus.border : themeContext.select.default.border,
          boxShadow: null,
          padding: '2px 0',

          '&:hover': {
            borderColor: state.isFocused ? themeContext.select.focus.border : themeContext.select.default.border,
          },
        }),
        option: (styles, state) => ({
          ...styles,
          color: state.isSelected || state.isFocused ? themeContext.select.focus.text : themeContext.select.default.text,
          backgroundColor: state.isSelected || state.isFocused ? themeContext.select.focus.bg : themeContext.select.default.bg,
          ':active': {
            ...styles[':active'],
            backgroundColor: themeContext.select.focus.bg,
          },
        }),
        menuPortal: (styles) => ({
          ...styles,
          zIndex: 100,
        }),
      }}
      {...rest}
      {...inputProps}
      value={selectValue}
      onChange={(evt) => {
        onChange(evt.value);
      }}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
    />
  );
};

export default Select;
